import classNames from "classnames";
import React, { useState } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { getCellStyle, getRowStyle, setCellAlignment } from "../utils";
import { getClassName } from "./Row";
import styled from "styled-components";
import RowAddTask from "./RowAddTask";
import { Box } from "@mui/material";
import DateRangeIcon from "@mui/icons-material/DateRange";

const ItemRow = ({
  id,
  width,
  projectId,
  isVisible = true,
  subRows = [],
  cells,
  groupId,
  indexGroup,
  canEdit,
}) => {
  const [keyEdit, setKeyEdit] = useState(false);
  const [afterTaskId, setAfterTaskId] = useState(undefined);

  const getStyleWrapper = (isDraggingOver) => {
    if (isDraggingOver)
      return { height: subRows.length * 48 || 48, background: "#edf8fd" };
    return {};
  };

  const editNameFinish = (key) => {
    if (!canEdit) return;
    setKeyEdit(key);
  };

  const handleFinishCreateTask = (newTask, isPressEnter) => {
    if (newTask) {
      setAfterTaskId(newTask?.id);
    } else {
      setAfterTaskId(undefined);
    }
    if (newTask || isPressEnter) return;
    setKeyEdit(false);
  };

  const ListCells = (row, provided, isDragging, editNameFinish) => {
    // if (isDragging && row.cells?.length > 0) {
    //   const cell = row.cells[0];
    //   const idCell = cell?.column?.id;
    //   return (
    //     <Box
    //       {...cell.getCellProps()}
    //       style={{
    //         ...getCellStyle(cell.getCellProps()),
    //         border: "1px solid rgb(3, 169, 244)",
    //       }}
    //       className={classNames("td", getClassName(idCell))}
    //     >
    //       {cell.render("Cell", {
    //         dragHandle:
    //           cell.idCell === "pfd-name" && canEdit
    //             ? provided.dragHandleProps
    //             : {},
    //         projectId,
    //         editNameFinish,
    //         canEdit: canEdit,
    //       })}
    //     </Box>
    //   );
    // }

    return row.cells.map((cell) => {
      const idCell = cell?.column?.id;
      const alignment = setCellAlignment(cell?.column?.alignment);

      return (
        <StyledDiv
          {...cell.getCellProps()}
          style={{
            ...getCellStyle(cell.getCellProps()),
            ...alignment,
            justifyContent: "flex-start",
            height: "100%",
            overflow: "hidden",
          }}
          className={classNames("td", getClassName(idCell))}
          isDuration={idCell === "pdf-duration"}
          alignment={cell?.column?.alignment}
        >
          {cell.render("Cell", {
            dragHandle:
              idCell === "pfd-name" && canEdit ? provided.dragHandleProps : {},
            projectId,
            editNameFinish,
            canEdit: canEdit,
          })}
        </StyledDiv>
      );
    });
  };
  console.log(subRows, "subRows");
  return (
    <>
      <Droppable droppableId={id} type="sub-row" key={id}>
        {(provided, snapshot) => {
          return (
            <div
              ref={provided.innerRef}
              className="wrapper-sub-rows"
              {...provided.droppableProps}
              style={{
                ...getStyleWrapper(snapshot.isDraggingOver),
                width: width - 100,
              }}
            >
              {subRows.map((row) => {
                return (
                  <React.Fragment key={row.original.id}>
                    <Draggable
                      draggableId={row.original.id}
                      key={row.original.id}
                      index={row.index}
                      isDragDisabled={!canEdit}
                    >
                      {(provided, snapshot) => {
                        if (typeof row?.getRowProps !== "function") return null;
                        const rowProps = row.getRowProps();
                        const finalStyle = getRowStyle(
                          rowProps,
                          provided.draggableProps,
                          snapshot.isDragging
                        );
                        return (
                          <>
                            <div
                              ref={provided.innerRef}
                              className="tr"
                              {...rowProps}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                ...finalStyle,
                                width,
                              }}
                            >
                              {ListCells(
                                row,
                                provided,
                                snapshot.isDragging,
                                editNameFinish
                              )}
                              {provided.placeholder}
                            </div>
                            {canEdit && keyEdit === row.id && (
                              <RowAddTask
                                id={`${row.id}`}
                                cells={cells}
                                indexGroup={indexGroup}
                                groupId={groupId}
                                projectId={projectId}
                                indexTask={row.id}
                                isMiddleRow={true}
                                afterTaskId={afterTaskId || row.original.id}
                                handleFinishCreateTask={handleFinishCreateTask}
                              />
                            )}
                          </>
                        );
                      }}
                    </Draggable>
                  </React.Fragment>
                );
              })}
              {subRows.length === 0 && <GhostRow></GhostRow>}
              {provided.placeholder}
            </div>
          );
        }}
      </Droppable>
    </>
  );
};

export const GhostRow = styled.div`
  height: 2px;
  width: 100%;
`;

export const StyledDiv = styled.div`
  > input,
  textarea {
    height: 100%;
  }

  text-align: ${(props) => {
    return props.alignment === 1
      ? "left"
      : props.alignment === "2"
      ? "center"
      : "right";
  }};
  justify-content: ${(props) => {
    return props.alignment === 1
      ? "flex-start"
      : props.alignment === "2"
      ? "center"
      : "flex-end";
  }};
  > input {
    text-align: ${(props) =>
      props.alignment === 1
        ? "left"
        : props.alignment === 2
        ? "center"
        : props.alignment === 3
        ? "right"
        : "right"}!important;
  }
  > div {
    justify-content: ${(props) =>
      props.alignment === 1
        ? "flex-start"
        : props.alignment === 2
        ? "center"
        : props.alignment === 3
        ? "flex-end"
        : "flex-start"};
  }
  > textarea {
    heigth: 100%;
    text-align: ${(props) =>
      props.alignment === 1
        ? "left"
        : props.alignment === 2
        ? "center"
        : props.alignment === 3
        ? "right"
        : "left"};
  }
`;

export default React.memo(ItemRow);
